import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * Feature 210: consent gate shown when a customer opens the "Registration Signup Link"
 * they received after a firm clicked "Move to Customer Referral".
 *
 * The customer must explicitly confirm they consent to their information being referred
 * to Senem RFP before the normal signup-questions flow becomes available.
 *   - Yes -> dialog closes with true, the signup form is shown.
 *   - No  -> dialog closes with false, the customer is sent back (nothing is created).
 */
@Component({
  selector: 'app-referral-consent-dialog',
  templateUrl: './referral-consent-dialog.component.html',
  styleUrls: ['./referral-consent-dialog.component.scss'],
})
export class ReferralConsentDialogComponent {
  constructor(public dialogRef: MatDialogRef<ReferralConsentDialogComponent>) {}

  agree(): void {
    this.dialogRef.close(true);
  }

  decline(): void {
    this.dialogRef.close(false);
  }
}
